import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import { omit, isArray, has } from 'lodash';
import displayName from 'component-lib/displayName';

import ActiveCell from './ActiveCell';
import { availableContextTypes } from './TableView';

import styles from './Table.scss';

const rowStatuses = {
    SELECTED: 'selected',
    DISABLED: 'disabled',
    UNSELECTABLE: 'unselectable',
    DISABLEDTOGGLE: 'disabledToggle',
};

export default class TableRow extends Component {
  static rowStatuses = rowStatuses; /* eslint-disable-line */

    static displayName = displayName('TableView/TableRow');

    static propTypes = {
        rowId: PropTypes.string.isRequired,
        index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        children: PropTypes.any,
        status: PropTypes.string,
        className: PropTypes.string,
    };

    static contextTypes = availableContextTypes;

    static childContextTypes = {
        firstColumnId: PropTypes.string,
    };

    static defaultProps = {
        children: null,
        status: '',
        className: '',
    };

    constructor(props) {
        super(props);

        this.tableRowRef = createRef();
    }

    getChildContext() {
        const { withActiveColumn } = this.context;
        const { children } = this.props;
        let cellId = '';

        // There needs to be at least one TableCell component for this to render
        if (isArray(children) && has(children[0], 'props.cellId')) {
            [
                {
                    props: { cellId = '' },
                },
            ] = children;
        }

        return { firstColumnId: withActiveColumn ? cellId : '' };
    }

    componentDidMount() {
    // We should want to keep the row as untouchable if unselectable
        this.interval = setInterval(() => {
            if (this.props.status === rowStatuses.UNSELECTABLE) {
                $(this.tableRowRef.current).css({ pointerEvents: 'none' });
            }
        }, 50);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    render() {
        const { status, rowId, index, children } = this.props;
        const { withActiveColumn } = this.context;
        const tableRowProps = omit(this.props, ['rowId', 'status', 'styleName', 'index', 'styles']);

        tableRowProps.className = styles['table-row'];

        if (status) {
            tableRowProps.className = styles[`${status}-row`];
            tableRowProps['data-row-status'] = status;
        }

        tableRowProps.className += ` ${this.props.className}`;

        return (
            <tr ref={this.tableRowRef} data-row-id={rowId} data-index={index} {...tableRowProps}>
                {withActiveColumn && <ActiveCell cellId="activeCell" />}
                {children}
            </tr>
        );
    }
}
